export const countries = [
  { code: '', ru: 'Все страны', gb: 'All countries' },
  { code: 'AE', ru: 'ОАЭ', gb: 'United Arab Emirates' },
  { code: 'AR', ru: 'Аргентина', gb: 'Argentina' },
  { code: 'AT', ru: 'Австрия', gb: 'Austria' },
  { code: 'AU', ru: 'Австралия', gb: 'Australia' },
  { code: 'AZ', ru: 'Азербайджан', gb: 'Azerbaijan' },
  { code: 'BA', ru: 'Босния и Герцеговина', gb: 'Bosnia and Herzegovina' },
  { code: 'BD', ru: 'Бангладеш', gb: 'Bangladesh' },
  { code: 'BE', ru: 'Бельгия', gb: 'Belgium' },
  { code: 'BG', ru: 'Болгария', gb: 'Bulgaria' },
  { code: 'BH', ru: 'Бахрейн', gb: 'Bahrain' },
  { code: 'BO', ru: 'Боливия', gb: 'Bolivia' },
  { code: 'BR', ru: 'Бразилия', gb: 'Brazil' },
  { code: 'BY', ru: 'Беларусь', gb: 'Belarus' },
  { code: 'CA', ru: 'Канада', gb: 'Canada' },
  { code: 'CH', ru: 'Швейцария', gb: 'Switzerland' },
  { code: 'CL', ru: 'Чили', gb: 'Chile' },
  { code: 'CO', ru: 'Колумбия', gb: 'Colombia' },
  { code: 'CR', ru: 'Коста-Рика', gb: 'Costa Rica' },
  { code: 'CY', ru: 'Кипр', gb: 'Cyprus' },
  { code: 'CZ', ru: 'Чехия', gb: 'Czech Republic' },
  { code: 'DE', ru: 'Германия', gb: 'Germany' },
  { code: 'DK', ru: 'Дания', gb: 'Denmark' },
  { code: 'DO', ru: 'Доминиканская Республика', gb: 'Dominican Republic' },
  { code: 'DZ', ru: 'Алжир', gb: 'Algeria' },
  { code: 'EC', ru: 'Эквадор', gb: 'Ecuador' },
  { code: 'EE', ru: 'Эстония', gb: 'Estonia' },
  { code: 'EG', ru: 'Египет', gb: 'Egypt' },
  { code: 'ES', ru: 'Испания', gb: 'Spain' },
  { code: 'FI', ru: 'Финляндия', gb: 'Finland' },
  { code: 'FR', ru: 'Франция', gb: 'France' },
  { code: 'GB', ru: 'Великобритания', gb: 'United Kingdom' },
  { code: 'GE', ru: 'Грузия', gb: 'Georgia' },
  { code: 'GH', ru: 'Гана', gb: 'Ghana' },
  { code: 'GR', ru: 'Греция', gb: 'Greece' },
  { code: 'GT', ru: 'Гватемала', gb: 'Guatemala' },
  { code: 'HK', ru: 'Гонконг', gb: 'Hong Kong' },
  { code: 'HN', ru: 'Гондурас', gb: 'Honduras' },
  { code: 'HR', ru: 'Хорватия', gb: 'Croatia' },
  { code: 'HU', ru: 'Венгрия', gb: 'Hungary' },
  { code: 'ID', ru: 'Индонезия', gb: 'Indonesia' },
  { code: 'IE', ru: 'Ирландия', gb: 'Ireland' },
  { code: 'IL', ru: 'Израиль', gb: 'Israel' },
  { code: 'IN', ru: 'Индия', gb: 'India' },
  { code: 'IQ', ru: 'Ирак', gb: 'Iraq' },
  { code: 'IS', ru: 'Исландия', gb: 'Iceland' },
  { code: 'IT', ru: 'Италия', gb: 'Italy' },
  { code: 'JM', ru: 'Ямайка', gb: 'Jamaica' },
  { code: 'JO', ru: 'Иордания', gb: 'Jordan' },
  { code: 'JP', ru: 'Япония', gb: 'Japan' },
  { code: 'KE', ru: 'Кения', gb: 'Kenya' },
  { code: 'KH', ru: 'Камбоджа', gb: 'Cambodia' },
  { code: 'KR', ru: 'Южная Корея', gb: 'South Korea' },
  { code: 'KW', ru: 'Кувейт', gb: 'Kuwait' },
  { code: 'KZ', ru: 'Казахстан', gb: 'Kazakhstan' },
  { code: 'LA', ru: 'Лаос', gb: 'Laos' },
  { code: 'LB', ru: 'Ливан', gb: 'Lebanon' },
  { code: 'LI', ru: 'Лихтенштейн', gb: 'Liechtenstein' },
  { code: 'LK', ru: 'Шри-Ланка', gb: 'Sri Lanka' },
  { code: 'LT', ru: 'Литва', gb: 'Lithuania' },
  { code: 'LU', ru: 'Люксембург', gb: 'Luxembourg' },
  { code: 'LV', ru: 'Латвия', gb: 'Latvia' },
  { code: 'LY', ru: 'Ливия', gb: 'Libya' },
  { code: 'MA', ru: 'Марокко', gb: 'Morocco' },
  { code: 'MD', ru: 'Молдова', gb: 'Moldova' },
  { code: 'ME', ru: 'Черногория', gb: 'Montenegro' },
  { code: 'MK', ru: 'Северная Македония', gb: 'North Macedonia' },
  { code: 'MT', ru: 'Мальта', gb: 'Malta' },
  { code: 'MX', ru: 'Мексика', gb: 'Mexico' },
  { code: 'MY', ru: 'Малайзия', gb: 'Malaysia' },
  { code: 'NG', ru: 'Нигерия', gb: 'Nigeria' },
  { code: 'NI', ru: 'Никарагуа', gb: 'Nicaragua' },
  { code: 'NL', ru: 'Нидерланды', gb: 'Netherlands' },
  { code: 'NO', ru: 'Норвегия', gb: 'Norway' },
  { code: 'NP', ru: 'Непал', gb: 'Nepal' },
  { code: 'NZ', ru: 'Новая Зеландия', gb: 'New Zealand' },
  { code: 'OM', ru: 'Оман', gb: 'Oman' },
  { code: 'PA', ru: 'Панама', gb: 'Panama' },
  { code: 'PE', ru: 'Перу', gb: 'Peru' },
  { code: 'PG', ru: 'Папуа-Новая Гвинея', gb: 'Papua New Guinea' },
  { code: 'PH', ru: 'Филиппины', gb: 'Philippines' },
  { code: 'PK', ru: 'Пакистан', gb: 'Pakistan' },
  { code: 'PL', ru: 'Польша', gb: 'Poland' },
  { code: 'PR', ru: 'Пуэрто-Рико', gb: 'Puerto Rico' },
  { code: 'PT', ru: 'Португалия', gb: 'Portugal' },
  { code: 'PY', ru: 'Парагвай', gb: 'Paraguay' },
  { code: 'QA', ru: 'Катар', gb: 'Qatar' },
  { code: 'RO', ru: 'Румыния', gb: 'Romania' },
  { code: 'RS', ru: 'Сербия', gb: 'Serbia' },
  { code: 'RU', ru: 'Россия', gb: 'Russia' },
  { code: 'SA', ru: 'Саудовская Аравия', gb: 'Saudi Arabia' },
  { code: 'SE', ru: 'Швеция', gb: 'Sweden' },
  { code: 'SG', ru: 'Сингапур', gb: 'Singapore' },
  { code: 'SI', ru: 'Словения', gb: 'Slovenia' },
  { code: 'SK', ru: 'Словакия', gb: 'Slovakia' },
  { code: 'SN', ru: 'Сенегал', gb: 'Senegal' },
  { code: 'SV', ru: 'Сальвадор', gb: 'El Salvador' },
  { code: 'TH', ru: 'Таиланд', gb: 'Thailand' },
  { code: 'TN', ru: 'Тунис', gb: 'Tunisia' },
  { code: 'TR', ru: 'Турция', gb: 'Turkey' },
  { code: 'TW', ru: 'Тайвань', gb: 'Taiwan' },
  { code: 'TZ', ru: 'Танзания', gb: 'Tanzania' },
  { code: 'UA', ru: 'Украина', gb: 'Ukraine' },
  { code: 'UG', ru: 'Уганда', gb: 'Uganda' },
  { code: 'US', ru: 'США', gb: 'United States' },
  { code: 'UY', ru: 'Уругвай', gb: 'Uruguay' },
  { code: 'VE', ru: 'Венесуэла', gb: 'Venezuela' },
  { code: 'VN', ru: 'Вьетнам', gb: 'Vietnam' },
  { code: 'YE', ru: 'Йемен', gb: 'Yemen' },
  { code: 'ZA', ru: 'ЮАР', gb: 'South Africa' },
  { code: 'ZW', ru: 'Зимбабве', gb: 'Zimbabwe' }
];